import {useGlobalSearchParams} from "expo-router";
import ChatPage from "@/lib/pages/ChatPage";
import SpinnerPage from "@/lib/pages/SpinnerPage";
import {useAccount} from "@/lib/providers/AccountProvider";

export default function Index() {
    const {chat_id} = useGlobalSearchParams();
    const {account} = useAccount();

    if (!chat_id || !account) {
        return <SpinnerPage title={"Laster chat..."}/>
    }

    return (
        <ChatPage chatId={chat_id.toString()}/>
    )
}